import { render } from "./footer.component.vue?vue&type=template&id=33528eab&ts=true"
import script from "./footer.component.ts?vue&type=script&lang=ts"
export * from "./footer.component.ts?vue&type=script&lang=ts"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__